import { createFileRoute } from '@tanstack/react-router';
import { ClientUnifiedNotificationSettingsPage } from '@/features/notifications/ClientUnifiedNotificationSettingsPage';
import { clientNotificationQueryOptions, smsConsentQueryOptions } from '@/lib/query/options';

export const Route = createFileRoute('/notification-settings')({
  loader: async ({ context: { queryClient } }) => {
    // Get auth state from cache
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | {
          token?: string;
          isAuthenticated?: boolean;
        }
      | undefined;

    // Get selected client ID from sessionStorage
    const clientId = sessionStorage.getItem('selectedClientId');

    if (authState?.token && clientId) {
      // Prefetch client notification preferences and SMS consent status in parallel
      await Promise.all([
        queryClient.prefetchQuery(clientNotificationQueryOptions.preferences(clientId, authState.token)),
        queryClient.prefetchQuery(smsConsentQueryOptions.status(authState.token)),
      ]);
    }
  },
  component: ClientUnifiedNotificationSettingsPage,
});
